import React from 'react';

import { Button, Input, InputNumber, notification, Form } from 'antd';
import { SendOutlined } from '@ant-design/icons';
import QuoteStore from '../../../stores/QuoteStore';
import { QuoteProps } from '@partsbadger/types';
import { QuoteLineItemProps } from '../../../types/types';

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
    },
};

interface PropsWithForm {
    quote: Pick<QuoteProps, 'id' | 'name'>;
    item?: QuoteLineItemProps;
    onCloseModal?: (value: boolean) => void;
}

export const RequestNewQuote: React.FC<PropsWithForm> = props => {
    const [form] = Form.useForm();

    const handleSubmit = (): void => {
        form.validateFields()
            .then(async values => {
                if (props.item) {
                    const payload = {
                        line_item_id: props.item.id,
                        manufacturing_type: props.item.manufacturing_type,
                        quantity: values.quantity,
                        material: props.item.product.material_related.id,
                        coating: props.item.product.coating_related.id,
                        finish: props.item.product.finish_related.id,
                        delivery: props.item.delivery,
                        unit_price: props.item.unit_price,
                        total_price: props.item.total_price,
                        generate_rfq: true,
                    };

                    QuoteStore.duplicateItemForRequote(props.quote.id, payload).then(() => {
                        notification['success']({
                            message: 'Message sent.',
                            description:
                                'Thank you for your message, the PartsBadger team will respond to your request soon.',
                        });
                        if (props.onCloseModal) props.onCloseModal(false);
                    });
                }
            })
            .catch(errorInfo => {
                notification.error({
                    duration: 10,
                    message: 'Error',
                    description: 'Required fields are empty!',
                    placement: 'topRight',
                });
            });
    };

    return (
        <>
            <Form key={'message'} {...formItemLayout} layout="vertical" onFinish={handleSubmit} form={form}>
                <Form.Item label="Quote" name="quote" rules={[{ required: true }]} initialValue={props.quote?.name}>
                    <Input readOnly={true} />
                </Form.Item>
                <Form.Item
                    label="Part Name"
                    name="part_name"
                    rules={[{ required: true }]}
                    initialValue={props.item?.name}
                >
                    <Input readOnly={true} />
                </Form.Item>
                <Form.Item
                    label="Quantity"
                    name="quantity"
                    rules={[{ required: true, message: 'Please input your quantity!' }]}
                >
                    <InputNumber style={{ width: '100%' }} />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        Send Message <SendOutlined />
                    </Button>
                </Form.Item>
            </Form>
        </>
    );
};

export default RequestNewQuote;
